<template>
    <v-row class="fill-height align-center no-gutters">
        <v-col class="d-flex flex-column justify-center col-6 fill-height">
            <image-mobile-app></image-mobile-app>
        </v-col>
        <v-col class="d-flex justify-center">
                <v-form class="wi-70" v-model="valid" >
                <p class="h2">Reset your password</p>
                <v-text-field required v-model="username" :rules="pseudoRules" label="Votre pseudo"></v-text-field>
                <v-text-field
                                required
                                v-model="password"
                                :rules="passwordRules"
                                label="New password"
                                :counter="20"
                                :type="showPwd ? 'text' : 'password'"
                                :append-icon="showPwd ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="showPwd = !showPwd">
                </v-text-field>
                <v-text-field   required
                                v-model="verifPwd"
                                :rules="passwordMatchRules"
                                label="New password confirmation"
                                counter
                                :type="showPwd ? 'text' : 'password'"
                                :append-icon="showPwd ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="showPwd = !showPwd">
                </v-text-field>
                <v-btn x-large :disabled="!valid" color="primary" class="mt-5" @click="validate()" >Reset</v-btn>
                <router-link to="/login" class="cursor-pointer caption text-decoration-none mb-0 forgot-link d-block">Remember your password ? login !</router-link>

            </v-form>
        </v-col>
    </v-row>
</template>

<style lang="scss" >
</style>

<script>
import imageMobileApp from '@/components/ImageMobileApp.vue'
import Vue from 'vue'
import { recaptchaKey, apiRoutes } from '@/../config'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import axios from 'axios'
Vue.use(VueReCaptcha, { siteKey: recaptchaKey })

export default {
    name: 'reset-password',
    components: { imageMobileApp },
    data () {
        return {
            valid: false,
            showPwd: false,
            password: '',
            verifPwd: '',
            username: '',
            passwordRules: [
                    v => !!v || 'A password is mandatory',
                    v => ((v && v.length >= 8)) || 'Your password must be at least 8 characters long',
                    v => (v && v.length <= 20) || 'Your password mus be at most 20 characters long'
            ],
            pseudoRules: [
                v => !!v || 'Your username is mandatory'
            ]
        }
    },
    async created () {
    },
    updated () {
    },
    methods: {
        async validate () {
            try {
                this.$store.dispatch('loading')
                const recaptcha = await this.$recaptcha('register')
                await axios.post(apiRoutes.resetPwd, { password: this.password, username: this.username, token: this.$route.params.forgotToken, recaptcha })
                this.$router.push('/')
                this.$store.dispatch('open_dialog', { message: 'Your password has been reset. You can now login and play !', button: 'Connexion', cb: () => { this.$store.dispatch('open_login_dialog', { use: 'login' }) } })
            } catch (e) {
                console.log(e)
                this.$store.dispatch('open_dialog', { message: 'Your username could not be found, please retry.' })
            } finally {
                this.$store.dispatch('stop_loading')
            }
        }
    },
    computed: {
        passwordMatchRules () {
            return [this.verifPwd === this.password || 'Your password and its confirmation dont match']
        }
    }
}
</script>
